import Head from "next/head";

import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";

import TForceMain from "@/components/fulfilment-partners/tforce-main";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";
import { GetStaticProps } from "next";

export default function TForcePartner({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <TForceMain />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_TFORCE },
  };
};
